import React from "react";
import classes from "./SkillBox.module.css";
import emoji2 from "../../assets/images/emojy/emojy2.png";
import html from '../../assets/images/skill/html.png';
import javascript from '../../assets/images/skill/javascript.png';
const SkillBox = () => {
  return (
    <div className={classes["skill-box"]}>
      <div className={classes["skill-talk-box"]}>
      저는 HTML, CSS, JavaScript를 기본으로, React와 Next.js 같은 프론트엔드 프레임워크와 Spring, Java를 활용한 백엔드 개발을 다룰 수 있는 웹 개발자입니다.<br/>
      저의 목표는 더 나은 웹 서비스를 만들어가는 것이며, 개발 과정에서 계속 배우고 성장하는 개발자가 되기 위해 노력하고 있습니다!
      </div>

      <div className={classes["img-box"]}>
        <img src={emoji2} />
      </div>

      <ul>
        <li></li>
      </ul>
    </div>
  );
};

export default SkillBox;
